<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div>
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg">
                                    <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.student.img" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row g-5">
                        <div class="col-lg-3">
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudProfile(this.studentId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewStudCourses(this.studentId)"><i class="feather-monitor"></i><span>{{'Courses' | translate}}</span></a></li>
                                                    <li><a (click)="viewWishlist(this.studentId)"><i class="feather-heart"></i><span>{{'fav' | translate}}</span></a></li>
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudSettings(this.studentId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">
                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">الدورات المفضلة لديك
                                        </h4>
                                    </div>

                                    <div class="row g-5">
                                        <div class="col-lg-4 col-md-6 col-12" *ngFor="let course of courses | paginate: { itemsPerPage: 6, currentPage: p }">
                                            <div class="rbt-card variation-01 rbt-hover" style="cursor: pointer;" (click)="viewCourseDetails(course.id)">
                                                <div class="rbt-card-img">
                                                    <a>
                                                        <img style="max-height: 220px;min-height: 220px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                                                    </a>
                                                </div>
                                                <div class="rbt-card-body">
                                                    <div class="rbt-card-top">
                                                        <!-- <div class="rbt-review">
                                                            <div class="rating">
                                                                <i class="fas fa-star"></i>
                                                                <i class="fas fa-star"></i>
                                                                <i class="fas fa-star"></i>
                                                                <i class="fas fa-star"></i>
                                                                <i class="fas fa-star"></i>
                                                            </div>
                                                        </div>
                                                        <div class="rbt-bookmark-btn">
                                                            
                                                        </div> -->
                                                    </div>
                                                    <h5 class="rbt-card-title" style="font-size: 20px;"><a>{{course.courseNameAr}}</a>
                                                    </h5>
                                                    <ul class="rbt-meta">
                                                        <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                                        <li>{{course.studentsNo}} {{'Students' | translate}}</li>
                                                    </ul>

                                                    <div class="rbt-card-bottom">
                                                        <div class="rbt-price" *ngIf="course.price === 0">
                                                            <span class="current-price">{{'Free' | translate}}</span>
                                                        </div>
                                                        <div class="rbt-price" *ngIf="course.price > course.offerPrice">
                                                            <span class="current-price">{{course.offerPrice}} {{'SAR' | translate}}</span>
                                                            <span class="off-price">{{course.price}} {{'SAR' | translate}}</span>
                                                        </div>
                                                        <div class="rbt-price" *ngIf="course.offerPrice > course.price">
                                                            <span class="current-price">{{course.price}} {{'SAR' | translate}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12 mt--60">
                                            <pagination-controls 
                                            class="rbt-pagination" 
                                            (pageChange)="p = $event"
                                            previousLabel=""
                                            nextLabel=""
                                            ></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
